import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { FilterFamilyVM } from 'practice/view-models/practice-edit-residence';
import { FormikProps } from 'formik';
import { FamilyModalVM } from '..';

interface FormProps {
  formContext: FormikProps<FamilyModalVM>;
  disabled?: boolean;
}

const FormComponent = ({ formContext, disabled }: FormProps): React.ReactElement => {
  const onChange = useEventCallback(
    (key: keyof FilterFamilyVM, value: FilterFamilyVM[keyof FilterFamilyVM]) => {
      formContext.setFieldValue('filter', {
        ...(formContext.values.filter || {}),
        [key]: value,
      });
    }
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Codice fiscale"
          aria-label="Codice fiscale"
          id="fiscal-code"
          value={formContext.values.filter?.fiscalCode?.toUpperCase() || ''}
          onChange={(event) => onChange('fiscalCode', event.target.value)}
          fullWidth
          disabled={disabled}
          inputProps={{ maxLength: '16' }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          fullWidth
          disabled={disabled}
          value={formContext.values.filter?.surname || ''}
          onChange={(event) => onChange('surname', event.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          fullWidth
          disabled={disabled}
          value={formContext.values.filter?.name || ''}
          onChange={(event) => onChange('name', event.target.value)}
        />
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Accordion Filter - Form component';

const Form = memo(FormComponent);

export default Form;
